import React from 'react';
import { Info } from '@phosphor-icons/react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { cn } from '../lib/utils';

/**
 * Keeps optional guidance available without competing with the user's task.
 * Use inline text instead for errors, warnings, consequences, and required steps.
 */
export default function InfoTip({
  children,
  content,
  label = 'More information',
  title,
  className,
  contentClassName,
  align = 'start',
  side = 'bottom',
}) {
  const guidance = content ?? children;

  if (!guidance) return null;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={label}
          className={cn(
            'inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-muted-foreground transition-colors',
            'hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
            className
          )}
        >
          <Info className="h-4 w-4" weight="bold" aria-hidden="true" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align={align}
        side={side}
        role="note"
        className={cn('w-[min(20rem,calc(100vw-2rem))] p-3', contentClassName)}
      >
        {title && <p className="mb-1 text-sm font-semibold text-foreground">{title}</p>}
        <div className="text-sm leading-5 text-muted-foreground">{guidance}</div>
      </PopoverContent>
    </Popover>
  );
}
